<template>
    <div class="mx-4 divide-y divide-gray-200">
        <div class="grid grid-cols-1 gap-x-4 gap-y-3 pb-2 pt-5 sm:grid-cols-3">
            <div></div>
            <div class="text-base font-semibold text-gray-700">
                {{ $t('experience_and_knowledge.knowledge') }}
            </div>
            <div class="text-center text-base font-semibold text-gray-700">
                {{ $t('experience_and_knowledge.experience') }}
            </div>
        </div>
        <ExperienceAndKnowledgeRow
            v-model:experience="
                account.compliance_profiles.esac.experience_and_knowledge.stocks_equity_funds_experience
            "
            v-model:knowledge="account.compliance_profiles.esac.experience_and_knowledge.stocks_equity_funds_knowledge"
            name="experience_and_knowledge.stocks_equity_funds"
            :label="$t('experience_and_knowledge.stocks_equity_funds')"></ExperienceAndKnowledgeRow>
        <ExperienceAndKnowledgeRow
            v-model:experience="account.compliance_profiles.esac.experience_and_knowledge.mixed_funds_etfs_experience"
            v-model:knowledge="account.compliance_profiles.esac.experience_and_knowledge.mixed_funds_etfs_knowledge"
            name="experience_and_knowledge.mixed_funds_etfs"
            :label="$t('experience_and_knowledge.mixed_funds_etfs')"></ExperienceAndKnowledgeRow>
        <ExperienceAndKnowledgeRow
            v-model:experience="account.compliance_profiles.esac.experience_and_knowledge.bonds_bond_funds_experience"
            v-model:knowledge="account.compliance_profiles.esac.experience_and_knowledge.bonds_bond_funds_knowledge"
            name="experience_and_knowledge.bonds_bond_funds"
            :label="$t('experience_and_knowledge.bonds_bond_funds')"></ExperienceAndKnowledgeRow>
        <ExperienceAndKnowledgeRow
            v-model:experience="account.compliance_profiles.esac.experience_and_knowledge.closed_ended_funds_experience"
            v-model:knowledge="account.compliance_profiles.esac.experience_and_knowledge.closed_ended_funds_knowledge"
            name="experience_and_knowledge.closed_ended_funds"
            :label="$t('experience_and_knowledge.closed_ended_funds')"></ExperienceAndKnowledgeRow>
        <ExperienceAndKnowledgeRow
            v-model:experience="
                account.compliance_profiles.esac.experience_and_knowledge.options_other_derivatives_experience
            "
            v-model:knowledge="
                account.compliance_profiles.esac.experience_and_knowledge.options_other_derivatives_knowledge
            "
            name="experience_and_knowledge.options_other_derivatives"
            :label="$t('experience_and_knowledge.options_other_derivatives')"></ExperienceAndKnowledgeRow>
        <ExperienceAndKnowledgeRow
            v-model:experience="account.compliance_profiles.esac.experience_and_knowledge.venture_capital_experience"
            v-model:knowledge="account.compliance_profiles.esac.experience_and_knowledge.venture_capital_knowledge"
            name="experience_and_knowledge.venture_capital"
            :label="$t('experience_and_knowledge.venture_capital')"></ExperienceAndKnowledgeRow>
        <ExperienceAndKnowledgeRow
            v-model:experience="
                account.compliance_profiles.esac.experience_and_knowledge
                    .other_shares_loans_in_private_companies_experience
            "
            v-model:knowledge="
                account.compliance_profiles.esac.experience_and_knowledge
                    .other_shares_loans_in_private_companies_knowledge
            "
            name="experience_and_knowledge.other_shares_loans_in_private_companies"
            :label="$t('experience_and_knowledge.other_shares_loans_in_private_companies')"></ExperienceAndKnowledgeRow>
        <ExperienceAndKnowledgeRow
            v-model:experience="
                account.compliance_profiles.esac.experience_and_knowledge.other_alternative_investments_experience
            "
            v-model:knowledge="
                account.compliance_profiles.esac.experience_and_knowledge.other_alternative_investments_knowledge
            "
            name="experience_and_knowledge.other_alternative_investments"
            :label="$t('experience_and_knowledge.other_alternative_investments')"></ExperienceAndKnowledgeRow>

        <div class="grid grid-cols-1 px-2 py-6">
            <BaseInputSelect
                v-model="
                    account.compliance_profiles.esac.experience_and_knowledge
                        .follow_market_prices_business_financial_news
                "
                name="experience_and_knowledge.follow_market_prices_business_financial_news"
                :options="investmentFollowMarketOptions"
                :label="$t('experience_and_knowledge.follow_market_prices_business_financial_news')"></BaseInputSelect>
        </div>
    </div>
</template>

<script setup lang="ts">
import { usePersonalAccountDataState } from '../../../../utilities/account/useAccountDataPersonal'
import { computed } from 'vue'
import { FollowMarketOption } from '../../../../typings'
import { i18n } from '../../../../localization'
import ExperienceAndKnowledgeRow from './ExperienceAndKnowledgeRow.vue'
import { getNaturalWidgetFormValidationRules, initializeNaturalWidgetForm } from './forms'
import BaseInputSelect from '../../../base/BaseInputSelect.vue'

const { naturalProfile: account } = usePersonalAccountDataState()

const investmentFollowMarketOptions = computed(() => {
    return Object.keys(FollowMarketOption).map((key) => {
        return {
            key: key,
            label: i18n.global.t('follow_market_options.' + FollowMarketOption[key]),
        }
    })
})
initializeNaturalWidgetForm(getNaturalWidgetFormValidationRules('experience_and_knowledge'))
</script>
